export default __webpack_public_path__ + "static/media/affiliatesMainBanner.f16faf5a.png";